import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
export const OfferStack = () => {
  const tomos = [{
    num: 1,
    title: 'POR QUÉ TU CABEZA NO PARA A LA NOCHE',
    desc: 'Entendé exactamente qué te está pasando para que nada de lo que venga después sea un misterio.',
    valor: '$5.000'
  }, {
    num: 2,
    title: 'CÓMO SACARTE DE LA CABEZA LO QUE TE QUEDA DANDO VUELTAS',
    desc: 'El paso a paso de la Descarga. Para vaciar pensamientos, pendientes y preocupaciones antes de dormir.',
    valor: '$5.000'
  }, {
    num: 3,
    title: 'QUÉ HACER EN EL MOMENTO CUANDO NO PODÉS DORMIR',
    desc: 'El protocolo completo para cuando ya estás en la cama y tu cabeza no para.',
    valor: '$5.000'
  }, {
    num: 4,
    title: 'CÓMO CORTAR LOS PENSAMIENTOS QUE TE EMPEORAN TODO',
    desc: 'Frenás ideas como "mañana voy a estar destruido" o "nunca voy a poder dormir bien".',
    valor: '$5.000'
  }, {
    num: 5,
    title: 'CÓMO LLEGAR A LA NOCHE MENOS PASADO DE VUELTAS',
    desc: 'Porque muchas veces el problema empieza durante el día. Este tomo te muestra cómo llegar más tranquilo.',
    valor: '$5.000'
  }, {
    num: 6,
    title: 'CÓMO ARMAR TU PROPIA FORMA DE DORMIR MEJOR',
    desc: 'Juntás todo y armás tu sistema personal. Para siempre. Sin probar cosas al azar.',
    valor: '$5.000'
  }];
  const bonuses = [{
    num: 1,
    title: 'CÓMO VOLVERTE A DORMIR SI TE DESPERTÁS EN MEDIO DE LA NOCHE',
    desc: 'Para no arruinar toda la noche cuando abrís los ojos a las 2 o 3 AM.',
    valor: '$3.000',
    img: 'https://images.unsplash.com/photo-1506880018603-83d5b814b5a6?w=300&q=80'
  }, {
    num: 2,
    title: 'QUÉ DECIRTE CUANDO TU CABEZA EMPIEZA A ASUSTARTE',
    desc: 'Frases simples y directas para cortar pensamientos de miedo, culpa o desesperación.',
    valor: '$3.000',
    img: 'https://images.unsplash.com/photo-1512820790803-83ca734da794?w=300&q=80'
  }, {
    num: 3,
    title: 'PLAN DE 21 DÍAS PARA DEJAR DE TERMINAR TODAS LAS NOCHES IGUAL',
    desc: 'Una guía práctica para aplicar todo en orden y notar cambios reales.',
    valor: '$3.000',
    img: 'https://images.unsplash.com/photo-1497633762265-9d179a990aa6?w=300&q=80'
  }];
  return <Section id="oferta" data-id="element-322">
      <div className="max-w-4xl mx-auto" data-id="element-323">
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-16 text-white" data-id="element-324">
          Todo lo que recibís hoy
        </h2>

        <div className="mb-20" data-id="element-325">
          <div className="flex items-center gap-4 mb-10 justify-center" data-id="element-326">
            <span className="text-3xl" data-id="element-327">📚</span>
            <h3 className="text-3xl font-bold text-white" data-id="element-328">LOS 6 TOMOS</h3>
          </div>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-329">
            {tomos.map(tomo => <motion.div key={tomo.num} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-night-800 p-6 rounded-xl border border-night-700 hover:border-accent-blue/50 transition-colors" data-id="element-330">
                <div className="text-accent-blue font-bold text-sm mb-2" data-id="element-331">
                  TOMO {tomo.num}
                </div>
                <h4 className="text-xl font-bold text-white mb-3" data-id="element-332">
                  {tomo.title}
                </h4>
                <p className="text-gray-400 text-sm mb-4" data-id="element-333">{tomo.desc}</p>
                <div className="text-gray-500 text-sm font-medium" data-id="element-334">
                  Valor: {tomo.valor}
                </div>
              </motion.div>)}
          </div>
        </div>

        <div className="mb-20" data-id="element-335">
          <div className="flex items-center gap-4 mb-10 justify-center" data-id="element-336">
            <span className="text-3xl" data-id="element-337">🎁</span>
            <h3 className="text-3xl font-bold text-white" data-id="element-338">
              LOS 3 BONUS EXCLUSIVOS
            </h3>
          </div>

          <div className="space-y-8" data-id="element-339">
            {bonuses.map((bonus, idx) => <motion.div key={bonus.num} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="bg-gradient-to-r from-night-800 to-night-900 p-6 md:p-8 rounded-2xl border border-cta/30 relative overflow-hidden flex flex-col md:flex-row gap-8 items-center" data-id="element-340">
                <div className="absolute top-4 right-4 bg-cta text-night-900 text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider z-10 shadow-lg" data-id="element-341">
                  Gratis por hoy
                </div>

                <a href="#compra" className="block w-full md:w-1/3 shrink-0 relative group" data-id="element-342">
                  <div className="absolute inset-0 bg-cta/20 rounded-xl blur-xl transition-all duration-300 group-hover:bg-cta/40" data-id="element-343" />
                  <img src={bonus.img} alt={`Bonus ${bonus.num}: ${bonus.title}`} className="relative z-10 w-full h-auto rounded-xl shadow-lg border border-night-700 group-hover:-translate-y-1 transition-transform duration-300" data-id="element-344" />
                </a>

                <div className="w-full md:w-2/3" data-id="element-345">
                  <div className="text-cta font-bold text-sm mb-2" data-id="element-346">
                    BONUS {bonus.num}
                  </div>
                  <h4 className="text-2xl font-bold text-white mb-3" data-id="element-347">
                    {bonus.title}
                  </h4>
                  <p className="text-gray-300 mb-4" data-id="element-348">{bonus.desc}</p>
                  <div className="text-gray-500 text-sm font-medium line-through" data-id="element-349">
                    Valor: {bonus.valor}
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>

        <div className="bg-night-900 border-2 border-accent-blue rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-350">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-accent-blue/5 blur-[100px] pointer-events-none" data-id="element-351" />

          <a href="#compra" className="block max-w-xs mx-auto mb-8 relative group" data-id="element-352">
            <img src="https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=400&q=80" alt="Libro Apagá la Cabeza y Dormite" className="relative z-10 w-full h-auto rounded-xl shadow-2xl border border-night-700 group-hover:scale-105 transition-transform duration-500" data-id="element-353" />
          </a>

          <div className="text-gray-400 text-xl mb-2 font-medium" data-id="element-354">
            VALOR TOTAL DEL SISTEMA:{' '}
            <span className="line-through" data-id="element-355">$39.000</span>
          </div>
          <div className="text-white text-2xl mb-6" data-id="element-356">
            HOY LO LLEVÁS TODO POR:
          </div>
          <div className="text-5xl md:text-7xl font-bold text-white mb-10 flex items-center justify-center gap-4" data-id="element-357">
            <span className="text-gray-500 text-3xl md:text-5xl line-through" data-id="element-358">
              $39.000
            </span>
            <span className="text-gradient" data-id="element-359">→</span>
            <span className="text-cta" data-id="element-360">$19.999</span>
          </div>

          <Button href="#compra" fullWidth className="max-w-2xl mx-auto mb-6 text-lg md:text-xl py-5" data-id="element-361">
            SÍ, QUIERO APAGAR LA CABEZA Y DORMIRME ESTA NOCHE
          </Button>

          <p className="text-gray-300 mb-4" data-id="element-362">
            Acceso inmediato · PDF descargable · Funciona esta misma noche
          </p>
          <p className="text-gray-500 text-sm flex items-center justify-center gap-2" data-id="element-363">
            🔒 Pago 100% seguro · Mercado Pago · Transferencia · Tarjeta
          </p>
        </div>
      </div>
    </Section>;
};